__turbopack_context__.v({
  "backLink": "register-module__B3synq__backLink",
  "btnLogin": "register-module__B3synq__btnLogin",
  "btnSpinner": "register-module__B3synq__btnSpinner",
  "btnSubmit": "register-module__B3synq__btnSubmit",
  "card": "register-module__B3synq__card",
  "cardHeader": "register-module__B3synq__cardHeader",
  "cardSubtitle": "register-module__B3synq__cardSubtitle",
  "cardTitle": "register-module__B3synq__cardTitle",
  "divider": "register-module__B3synq__divider",
  "dividerLine": "register-module__B3synq__dividerLine",
  "dividerText": "register-module__B3synq__dividerText",
  "errorBanner": "register-module__B3synq__errorBanner",
  "eyeBtn": "register-module__B3synq__eyeBtn",
  "fadeUp": "register-module__B3synq__fadeUp",
  "fieldError": "register-module__B3synq__fieldError",
  "fieldGroup": "register-module__B3synq__fieldGroup",
  "industryCard": "register-module__B3synq__industryCard",
  "industryCardActive": "register-module__B3synq__industryCardActive",
  "industryCheck": "register-module__B3synq__industryCheck",
  "industryGrid": "register-module__B3synq__industryGrid",
  "industryImg": "register-module__B3synq__industryImg",
  "industryLabel": "register-module__B3synq__industryLabel",
  "industryName": "register-module__B3synq__industryName",
  "input": "register-module__B3synq__input",
  "inputError": "register-module__B3synq__inputError",
  "inputWrap": "register-module__B3synq__inputWrap",
  "label": "register-module__B3synq__label",
  "logoWrap": "register-module__B3synq__logoWrap",
  "page": "register-module__B3synq__page",
  "spinIcon": "register-module__B3synq__spinIcon",
  "termsCheckbox": "register-module__B3synq__termsCheckbox",
  "termsLink": "register-module__B3synq__termsLink",
  "termsRow": "register-module__B3synq__termsRow",
  "termsText": "register-module__B3synq__termsText",
});
